export function privFor(user, path) {
  const pr = user?.priv_routes || {};
  if (user?.role === "root" || user?.role_name === "Owner") return null;
  let best = null;
  for (const r of Object.keys(pr)) {
    if ((path === r || path.startsWith(r + "/")) && (!best || r.length > best.length)) best = r;
  }
  return best ? pr[best] : null;
}
